import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { StoreService } from '../../../core/services/store/store.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements AfterViewInit, OnInit {
  userToken: string;
  currentYear = new Date().getUTCFullYear();
  applyMargin = true;

  constructor(private storeService: StoreService, private router: Router) {}

  ngAfterViewInit() {
    this.createMicrofrontendScript();
  }

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: any) => {
      this.applyMargin = !event.url.includes('err') && !event.url.includes('negado');
    });

    this.applyMargin = !this.router.url.includes('err') && !this.router.url.includes('negado');
  }

  createMicrofrontendScript(): void {
    this.storeService.widgetList.subscribe((widgetList) => {
      const microfrontend = widgetList.find((el) => el.tag_html === 'mfe-botao-termos');

      if (!microfrontend) {
        return;
      }

      const script = document.createElement('script');
      script.src = microfrontend.url;
      document.body.appendChild(script);
    });
  }
}
